// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-smart-component {
  --height-smart-component-compact: 158px;
  --padding-component: 10px;
  --size-icon-main: 50px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  padding: var(--padding-component);
  background-color: white;
  min-height: var(--height-smart-component-compact);
}
.container-smart-component.supervision-view {
  --size-icon-main: 70px;
  --height-smart-component-compact: 70px;
  --padding-component: 0;
  height: -moz-fit-content;
  height: fit-content;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 200px;
  box-shadow: none;
  background-color: transparent;
}
.container-smart-component ion-button[disabled] {
  opacity: 1;
}

.icon-and-text {
  display: flex;
  align-items: center;
  gap: 10px;
}
.icon-and-text.right-orientation {
  flex-direction: row-reverse;
  text-align: right;
}
.icon-and-text.up-orientation {
  gap: 5px;
  flex-direction: column;
  text-align: center;
  justify-content: center;
}
.icon-and-text.up-orientation .title {
  line-height: 2.1;
}
.icon-and-text.down-orientation {
  flex-direction: column-reverse;
  text-align: center;
  justify-content: center;
}

.alarms {
  margin-inline-start: auto;
  display: flex;
  gap: 10px;
}
.alarms ion-icon {
  font-size: 48px;
  color: #9e0505;
}

.title {
  font-size: 18px;
  font-weight: 600;
}

.supervision-view .title {
  font-size: 15px;
}
.supervision-view .icon-main ion-icon {
  font-size: 50px;
}

.container-spinner {
  height: calc(var(--height-smart-component-compact) - var(--padding-component) * 2);
  width: 100%;
}

ion-icon.sunrise {
  color: #f9a60b;
}
ion-icon.sunset {
  color: #ff5900;
}
ion-icon.brightness {
  color: #ff2727;
}
ion-icon.wind {
  color: #77a5c6;
}
ion-icon.temperature {
  color: #5600BF;
}

.data {
  container-type: inline-size;
  container-name: weather-station-container;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  min-height: calc(var(--height-smart-component-compact) - var(--padding-component) * 2 - var(--size-icon-main));
}
.data ion-icon {
  font-size: 24px;
}
.data > * {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  font-weight: 600;
  gap: 10px;
}

.icon-main {
  width: var(--size-icon-main);
  height: var(--size-icon-main);
  flex-shrink: 0;
  background-color: #08a1ff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon-main.isNight {
  background-color: #023167;
}
.icon-main ion-icon {
  color: #fff;
  font-size: 35px;
}

@container weather-station-container (width < 310px) {
  .data > * {
    flex-basis: auto;
  }
}
@container weather-station-container (width > 310px) and (width < 400px) {
  .data > * {
    font-size: 18px;
    flex-basis: 100px;
  }
}
@container weather-station-container (width > 400px) {
  .data > * {
    flex-basis: 120px;
    font-size: 23px;
  }
}
@container weather-station-container (width > 480px) {
  .data > * {
    flex-basis: 160px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/widget-weather-station/widget-weather-station.component.scss","webpack://./src/components/shared-components/styles/mixins.scss"],"names":[],"mappings":"AAEA;ECDI,uCAAA;EACA,yBAAA;EACA,sBAAA;EACA,iDAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,iCAAA;EACA,uBAAA;EACA,iDAAA;ADCJ;ACCI;EACI,sBAAA;EACA,sCAAA;EACA,sBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;ADCR;ACEI;EACI,UAAA;ADAR;;AAlBA;ECuBI,aAAA;EACA,mBAAA;EACA,SAAA;ADDJ;ACGI;EACI,2BAAA;EACA,iBAAA;ADDR;ACII;EACI,QAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;ADFR;ACIQ;EACI,gBAAA;ADFZ;ACMI;EACI,8BAAA;EACA,kBAAA;EACA,uBAAA;ADJR;;AAtCA;EACE,yBAAA;EACA,aAAA;EACA,SAAA;AAyCF;AAvCE;EACE,eAAA;EACA,cAAA;AAyCJ;;AArCA;EC+CI,eAAA;EACA,gBAAA;ADNJ;;AArCE;EACE,eAAA;AAwCJ;AArCE;EACE,eAAA;AAuCJ;;AAnCA;ECsBI,kFAAA;EACA,WAAA;ADiBJ;;AAnCE;EACE,cAAA;AAsCJ;AAnCE;EACE,cAAA;AAqCJ;AAlCE;EACE,cAAA;AAoCJ;AAjCE;EACE,cAAA;AAmCJ;AAhCE;EACE,cAAA;AAkCJ;;AA9BA;EACE,2BAAA;EACA,yCAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;EACA,8GAAA;AAiCF;AA/BE;EACE,eAAA;AAiCJ;AA9BE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;AAgCJ;;AA5BA;ECtBI,4BAAA;EACA,6BAAA;EACA,cAAA;EDsBF,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAiCF;AA/BE;EACE,yBAAA;AAiCJ;AA9BE;EACE,WAAA;EACA,eAAA;AAgCJ;;AA5BA;EAEI;IACE,gBAAA;EA8BJ;AACF;AA1BA;EAEI;IACE,eAAA;IACA,iBAAA;EA2BJ;AACF;AAvBA;EAEI;IACE,iBAAA;IACA,eAAA;EAwBJ;AACF;AApBA;EAEI;IACE,iBAAA;EAqBJ;AACF","sourcesContent":["@use \"../../styles/mixins\" as *;\n\n.container-smart-component {\n  @include external-apparance;\n}\n\n.icon-and-text {\n  @include icon-and-text;\n}\n\n.alarms {\n  margin-inline-start: auto;\n  display: flex;\n  gap: 10px;\n\n  ion-icon {\n    font-size: 48px;\n    color: #9e0505;\n  }\n}\n\n.title {\n  @include title-main;\n}\n\n.supervision-view {\n  .title {\n    font-size: 15px;\n  }\n\n  .icon-main ion-icon {\n    font-size: 50px;\n  }\n}\n\n.container-spinner {\n  @include container-spinenr;\n}\n\nion-icon {\n  &.sunrise {\n    color: #f9a60b;\n  }\n\n  &.sunset {\n    color: #ff5900;\n  }\n\n  &.brightness {\n    color: #ff2727;\n  }\n\n  &.wind {\n    color: #77a5c6;\n  }\n\n  &.temperature {\n    color: #5600BF;\n  }\n}\n\n.data {\n  container-type: inline-size;\n  container-name: weather-station-container;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n  align-items: center;\n  min-height: calc(var(--height-smart-component-compact) - (var(--padding-component) * 2) - var(--size-icon-main));\n\n  ion-icon {\n    font-size: 24px;\n  }\n\n  &>* {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    line-height: 1;\n    font-weight: 600;\n    gap: 10px;\n  }\n}\n\n.icon-main {\n  @include icon-main;\n  background-color: #08a1ff;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &.isNight {\n    background-color: #023167;\n  }\n\n  ion-icon {\n    color: #fff;\n    font-size: 35px;\n  }\n}\n\n@container weather-station-container (width < 310px) {\n  .data {\n    &>* {\n      flex-basis: auto;\n    }\n  }\n}\n\n@container weather-station-container (width > 310px) and (width < 400px) {\n  .data {\n    &>* {\n      font-size: 18px;\n      flex-basis: 100px;\n    }\n  }\n}\n\n@container weather-station-container (width > 400px) {\n  .data {\n    &>* {\n      flex-basis: 120px;\n      font-size: 23px;\n    }\n  }\n}\n\n@container weather-station-container (width > 480px) {\n  .data {\n    &>* {\n      flex-basis: 160px;\n    }\n  }\n}","@mixin external-apparance {\n    --height-smart-component-compact: 158px;\n    --padding-component: 10px;\n    --size-icon-main: 50px;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    border-radius: 15px;\n    display: flex;\n    flex-direction: column;\n    padding: var(--padding-component);\n    background-color: white;\n    min-height: var(--height-smart-component-compact);\n\n    &.supervision-view {\n        --size-icon-main: 70px;\n        --height-smart-component-compact: 70px;\n        --padding-component: 0;\n        height: fit-content;\n        width: fit-content;\n        max-width: 200px;\n        box-shadow: none;\n        background-color: transparent;\n    }\n\n    ion-button[disabled] {\n        opacity: 1;\n    }\n}\n\n@mixin icon-and-text {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    &.right-orientation {\n        flex-direction: row-reverse;\n        text-align: right;\n    }\n\n    &.up-orientation {\n        gap: 5px;\n        flex-direction: column;\n        text-align: center;\n        justify-content: center;\n\n        .title {\n            line-height: 2.1;\n        }\n    }\n\n    &.down-orientation {\n        flex-direction: column-reverse;\n        text-align: center;\n        justify-content: center;\n    }\n}\n\n@mixin container-spinenr {\n    height: calc(var(--height-smart-component-compact) - (var(--padding-component) * 2));\n    width: 100%;\n}\n\n@mixin icon-main {\n    width: var(--size-icon-main);\n    height: var(--size-icon-main);\n    flex-shrink: 0;\n}\n\n@mixin title-main {\n    font-size: 18px;\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
